<script lang="ts">
	import HugeHeading from "@components/HugeHeading.svelte";
	import PartnerCard from "@components/PartnerCard.svelte";
	import Slideshow from "@components/common/Slideshow.svelte";
	import type { ClassValue } from "svelte/elements";
	import type { WebPartner } from "@core/schema/WebPartner.js";

	const { partners, class: customClass }: { partners: WebPartner[]; class?: ClassValue } = $props();
</script>

<section class={[customClass, "full-width py-8 md:py-16 lg:py-20"]}>
	<HugeHeading level={2} text="stroke[[Bez koho by to nešlo?]]" class="text-center" />
	<Slideshow class="gap-2 pl-2 mt-1 sm:mt-4" flowDirection="right" speed={1}>
		{#each partners as partner (partner.id)}
			<PartnerCard {partner} />
		{/each}
	</Slideshow>
</section>
